import React, { useState, useEffect } from "react";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { Box, TableCell, TableRow } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  FRIEND_TRANSFER_REMARK_COL,
  FRIEND_TRANSFER_TABLE_COL,
} from "../../../contants/table/friendTransfer";
import tableStyle from "../../../theme/styles/table";
import styles from "./styles";
import PendingTab from "../../../components/PendingTab";
import {
  forwardIntro,
  rejectIntro,
  fetchIntroductionRemarksData,
} from "../../../redux/actions/introduction";
import { convertDateTimeToDate } from "../../../utils/dateAndTime";
import { INTRODUCTION_TYPE } from "../../../contants";
import Table from "../../../components/common/new/Table/Table";

const getRows = (data) =>
  data?.map((friendInfo) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell> {friendInfo.frinedsName} </TableCell>
      <TableCell>
        <LocationOnIcon style={tableStyle.locationIcon} />{" "}
        {friendInfo.friendAddress}
      </TableCell>
      <TableCell sx={{ maxWidth: "12rem" }}>
        <PhoneIcon style={tableStyle.icon} /> {friendInfo.phone} <br />
        <>
          {" "}
          <EmailIcon style={tableStyle.icon} /> {friendInfo.email}{" "}
        </>
      </TableCell>
      <TableCell>{friendInfo.area} </TableCell>
      <TableCell>{friendInfo.cluster} </TableCell>
      <TableCell>{friendInfo.zone} </TableCell>
      <TableCell>{friendInfo.region} </TableCell>
      <TableCell>{friendInfo.chapter} </TableCell>
      <TableCell>{friendInfo.district} </TableCell>
    </TableRow>
  ));

const getRemarkRows = (data) =>
  data.map((remarker, i) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell>{i + 1}. </TableCell>
      <TableCell sx={{ display: "flex" }}>
        <Box
          component="img"
          sx={{
            height: 22,
            width: 22,
            borderRadius: "50%",
            marginRight: ".5rem",
          }}
          alt="The house from the offer."
          src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
        />{" "}
        {remarker.createdByUser?.fullName}{" "}
      </TableCell>
      <TableCell>{remarker?.data?.message} </TableCell>
      <TableCell>{convertDateTimeToDate(remarker?.createdAt)} </TableCell>
    </TableRow>
  ));

export default function IntroductionPending() {
  const TITLE = "Introduction Pending - BSG";
  const [rowList, setRowList] = useState([]);
  const { id } = useParams();
  const dispatch = useDispatch();

  const selectedIntroduction = useSelector(
    (store) => store.view_introduction.selectedIntroduction
  );
  const selectedIntroductionRemarksData = useSelector(
    (state) => state.view_introduction.selectedIntroduction.remarks.data
  );

  useEffect(() => {
    if (!rowList?.length && selectedIntroduction) {
      setRowList([
        {
          id: selectedIntroduction.introductionId,
          frinedsName: selectedIntroduction.fullName,
          friendAddress: selectedIntroduction.addressLine1,
          phone: selectedIntroduction.mobileNumber,
          email: selectedIntroduction.emailId,
          division: selectedIntroduction.divisionName,
          area: selectedIntroduction.areaName,
          cluster: selectedIntroduction.clusterName,
          zone: selectedIntroduction.zoneName,
          region: selectedIntroduction.regionName,
          chapter: selectedIntroduction.chapterName,
          district: selectedIntroduction.districtName,
          selectButton: true,
        },
      ]);
    }
  }, [selectedIntroduction]);

  useEffect(() => {
    fetchIntroductionRemarksData(dispatch, id);
  }, [id]);

  const refreshRemarks = () => {
    fetchIntroductionRemarksData(dispatch, id);
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box sx={styles.container}>
        <Table columns={FRIEND_TRANSFER_TABLE_COL} rows={getRows(rowList)} />
        <PendingTab
          firstTabTitle="Assign To"
          secondTabTitle="Reject Introduction"
          selectedItem={selectedIntroduction}
          onFinalSubmit={forwardIntro}
          onFinalReject={rejectIntro}
          pageType={INTRODUCTION_TYPE}
          refreshRemarks={refreshRemarks}
        />
        <Table
          columns={FRIEND_TRANSFER_REMARK_COL}
          rows={getRemarkRows(selectedIntroductionRemarksData || [])}
        />
      </Box>
    </>
  );
}
